export enum DeliveryMethods {
  TEXT_SMS = 'textSMS',
  EMAIL = 'email',
  PRINT = 'print',
}
